import { defineMeta } from '@/registry/types';

export const fabMeta = defineMeta({
  name: 'FAB',
  level: 'atom',
  category: 'input',
  classification: 'themed-mui',
  description: 'Floating action button for the primary, most-common screen action. Themed MUI Fab.',
  baseLibrary: '@mui/material',
  muiEquivalent: 'Fab',
  muiDocs: 'https://mui.com/material-ui/react-floating-action-button/',
  a2uiEquivalent: 'FloatingActionButton',
  importPath: '@/atoms/FAB',
  optionalProps: ['color', 'size', 'variant', 'disabled', 'onClick'],
  supportedStates: ['default', 'hover', 'extended', 'disabled'],
  designTokens: ['colors', 'shadows'],
  accessibility: ['Always provide aria-label for icon-only FABs.'],
  usageExamples: ['<Fab color="primary" aria-label="add"><AddIcon /></Fab>'],
  antiPatterns: ['Do not use more than one FAB per screen.'],
  llmSafe: true,
  whenToUse: ['Single primary action on mobile/dense screens'],
  whenNotToUse: ['Multiple equal actions (use Button)'],
});

export default fabMeta;
